var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-wrap",attrs:{"id":'yt-' + _vm.id}},[_c('iframe',{attrs:{"src":'//www.youtube.com/embed/'+_vm.id,"frameborder":"0","width":"640","height":"360"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-713e8778","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subparts/VideoYoutube.vue
// module id = null
// module chunks = 